module.exports = {
	"header": "Password & security",
	"changePassword": "Change password",
	"createPassword": "Create password",
	"createPasswordText": "Creating a password allows you to log in with your username and password.",
	"currentPassword": "Current password",
	"newPassword": "New password",
	"password": "Password",
	"pwFieldEmpty": "You must provide a password.",
	"pwNotIdentical": "Provided password fields are not the same.",
	"pwsGood": "Good",
	"pwsStrong": "Strong",
	"pwsTooWeak": "Too weak",
	"pwsVeryStrong": "Very Strong",
	"pwsWeak": "Weak",
	"pwTooShort": "Provided password is too short. It must be 8 characters or more.",
	"repeatNewPassword": "Repeat new password",
	"forgotPw": {
		"request": "A password reset was requested for the __brand__ account tied to __userEmail__.",
		"errorSocial": "This e-mail has an account associated with an external login. Please login using one of the following: __socialAccounts__.",
		"errorNoAccount": "However, it seems that no such account exists. Perhaps have you registered using a different email address? If you didn't request that change, please ignore this email.",
		"errorNoPassword": "There's no password that has been set for this e-mail address.",
		"header": "Forgot your password?",
		"repeatPassword": "Repeat password",
		"textLn1": "Enter your e-mail to reset your password:",
		"emailSent": "An e-mail containing a link to reset your password has been sent to you at the following address"
	},
	"resetPw": {
		"errorEmpty": "Please enter a new password. Fields cannot be empty.",
		"errorLinkNotValid": "This is not a valid password reset link.",
		"errorNotIdentical": "Password fields are not identical.",
		"newPassword": "New Password:",
		"repeatNewPassword": "Repeat new password:",
		"resetPassword": "Reset password",
		"success": "Password is now reset. You may now login with your new password.",
		"header": "Password reset"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/password.json5
// module id = 1949
// module chunks = 6